import { Fragment, h, VNode } from "preact";
import { useState } from "preact/compat";
import {
  Notification,
  useCommonPreferences,
  useTranslationContext,
} from "../index.browser.js";
import { Attention } from "./Attention.js";

export function LocalNotificationBanner({
  notification,
}: {
  notification?: Notification;
}): VNode {
  const { i18n } = useTranslationContext();
  const [{ showDebugInfo }] = useCommonPreferences();
  const [moreInfo, setMoreInfo] = useState(false);
  if (!notification) return <Fragment />;
  switch (notification.message.type) {
    case "error":
      const desc = notification.message.description;
      return (
        <div class="relative">
          <div class="fixed top-0 left-0 right-0 z-20 w-full p-4">
            <Attention
              type="danger"
              title={notification.message.title}
              onClose={() => {
                notification.acknowledge();
              }}
            >
              {desc &&
                desc.length &&
                (moreInfo ? (
                  desc.map((d) => {
                    return <div class="mt-2 text-sm text-red-700">{d}</div>;
                  })
                ) : (
                  <div class="mt-2 text-sm text-red-700">{desc[0]}</div>
                ))}

              <div class="flex justify-between">
                <div class="text-[grey]">
                  {moreInfo || (desc && desc.length < 2) ? undefined : (
                    <button onClick={() => setMoreInfo(true)} class="text-grey">
                      <i18n.Translate>Show more info</i18n.Translate>
                    </button>
                  )}
                </div>
              </div>
              {showDebugInfo && (
                <pre class="whitespace-break-spaces text-black">
                  {JSON.stringify(notification.message.debug, undefined, 2)}
                </pre>
              )}
            </Attention>
          </div>
        </div>
      );
    case "info":
      return (
        <div class="relative">
          <div class="fixed top-0 left-0 right-0 z-20 w-full p-4">
            <Attention
              type="success"
              title={notification.message.title}
              onClose={() => {
                notification.acknowledge();
              }}
            />
          </div>
        </div>
      );
  }
}

export function LocalNotificationBannerBulma({
  notification,
}: {
  notification?: Notification;
}): VNode {
  const { i18n } = useTranslationContext();
  const [{ showDebugInfo }] = useCommonPreferences();
  const [moreInfo, setMoreInfo] = useState(showDebugInfo);
  if (!notification) return <Fragment />;
  const msg = notification.message;
  switch (msg.type) {
    case "error":
      return (
        <div style={{ position: "relative" }}>
          <div
            style={{
              position: "fixed",
              zIndex: 99,
              top: 0,
              left: 0,
              right: 0,
              width: "100%",
            }}
          >
            <div class="notification">
              <div class="columns is-vcentered">
                <div class="column is-12">
                  <article class="message is-danger">
                    <div class="message-header">
                      <p>{msg.title}</p>
                      <button
                        class="delete "
                        aria-label="close"
                        onClick={() => notification.acknowledge()}
                      />
                    </div>
                    {msg.description && msg.description.length && (
                      <div class="message-body">
                        {moreInfo ? (
                          msg.description.map((d) => {
                            return <div>{d}</div>;
                          })
                        ) : (
                          <div>{msg.description[0]}</div>
                        )}
                        {moreInfo || msg.description.length === 1 ? (
                          undefined
                        ) : (
                          <a
                            onClick={() => setMoreInfo(true)}
                            type="button"
                            style={{ justifySelf: "right", color: "gray" }}
                          >
                            <i18n.Translate>show more info</i18n.Translate>
                          </a>
                        )}
                        {showDebugInfo && msg.debug && (
                          <pre> {JSON.stringify(msg.debug, undefined, 2)}</pre>
                        )}
                      </div>
                    )}
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    case "info":
      return (
        <div style={{ position: "relative" }}>
          <div
            style={{
              position: "fixed",
              zIndex: 99,
              top: 0,
              left: 0,
              right: 0,
              width: "100%",
            }}
          >
            <div class="notification">
              <div class="columns is-vcentered">
                <div class="column is-12">
                  <article class="message is-info">
                    <div class="message-header">
                      <p>{msg.title}</p>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}
